window.GalleryBox = function (params) {
	if (Array.isArray(params.pictures)) {
		this.picturesPath = params.pictures;
	} else {
		this.picture = params.pictures
	}
	this.plug = params.plug;
	this.id = params.id;
	this.name = params.name;
	this.zoomButton = BX.findChild(BX(params.id), {
		"class": "picture-zoom"
	}, true);

	this.currentPictureIndex = 0;
	this.body = document.querySelector("body");
	this.bodyOpenedClass = "k1-modal-opened";
	this.swipeStart = 0;
	this.swipeEnd = 0;


	this.noZoomButton = params.noZoom;
	this.clickItemClass = params.className;

	this.dotsBlock = null;

	BX.ready(BX.delegate(this.init, this))
};

window.GalleryBox.prototype = {
	init: function () {
		this.bindElements();
	},

	getModal: function () {
		const modal = document.querySelector(".k1-modal.k1-modal__bg");
		return {
			modalWrapper: modal,
			next: modal.querySelector(".k1-modal__next"),
			prev: modal.querySelector(".k1-modal__prev"),
			picture: modal.querySelector(".k1-modal-popup-slider__picture"),
		}
	},

	changeBodyOverflow: function (node) {
		if (node.classList.contains(this.bodyOpenedClass)) {
			node.style.overflow = "hidden"
		} else {
			node.style.overflow = "auto"
		}
	},

	bindElements: function () {
		if (this.noZoomButton) {
			const buttons = document.querySelectorAll(`.${this.clickItemClass}`);
			buttons.forEach(button => {
				BX.unbind(button, "click", BX.proxy(this.openGallery, this));
				BX.bind(button, "click", BX.proxy(this.openGallery, this));
			}, this)
		} else {
			BX.bind(this.zoomButton, "click", BX.proxy(this.openGallery, this))
		}

	},

	setCurrentPicture(index) {
		this.getModal().picture.querySelector("img").setAttribute("src", this.picturesPath[index]);
	},

	openGallery: function (event) {
		event.preventDefault();
		const modal = this.getModal().modalWrapper;
		modal.style.display = "flex";
		this.body.classList.add(this.bodyOpenedClass);
		this.changeBodyOverflow(this.body);
		if (this.picture) {
			this.getModal().picture.querySelector("img").setAttribute("src", this.picture);
			this.getModal().next.style.display = "none";
			this.getModal().prev.style.display = "none";
		}

		if (this.picturesPath) {
			if (event.target.tagName === "IMG") {
				let currentPicturePath = event.target.getAttribute("src")
				this.currentPictureIndex = this.picturesPath.findIndex(elem => elem === currentPicturePath);
			}
			this.dotsBlock = modal.querySelector(".k1-modal-dots");
			this.setCurrentPicture(this.currentPictureIndex);
			this.getModal().next.style.display = "block";
			this.getModal().prev.style.display = "block";
			this.makeDots(this.currentPictureIndex);



			BX.bind(this.getModal().picture, "mousedown", BX.delegate(this.setSwipeStart, this));
			BX.bind(this.getModal().picture, "touchstart", BX.delegate(this.setSwipeStart, this));
			BX.bind(this.getModal().picture, "mouseup", BX.delegate(this.setSwipeEnd, this));
			BX.bind(this.getModal().picture, "touchend", BX.delegate(this.setSwipeEnd, this));
			BX.bind(modal, "click", BX.proxy(this.changePicture, this));
		}
		BX.bind(modal, "click", BX.proxy(this.closeGallery, this));
	},

	closeGallery: function (event) {
		const modal = this.getModal().modalWrapper;
		const target = event.target;
		if (target.closest(".k1-modal__close") || !target.closest(".k1-modal__body")) {
			modal.style.display = "none";
			this.body.classList.remove(this.bodyOpenedClass);
			this.changeBodyOverflow(this.body);
			BX.unbindAll(modal);
			this.getModal().picture.querySelector("img").setAttribute("src", "");
			modal.querySelector(".k1-modal-dots").innerHTML = '';
		}
	},

	changePicture: function (event, swipe) {
		if (swipe) {
			let different = this.swipeEnd - this.swipeStart;

			if (Math.abs(different) < 40) return false;

			if (different > 0) {
				this.prevPicture()
			} else {
				this.nextPicture()
			}

			return false;
		}

		const next = this.getModal().next;
		const prev = this.getModal().prev;
		const dots = document.querySelectorAll(".k1-modal-dots .k1-modal-dot");
		const target = event.target;
		let currentIndex;
		if (target === next) this.nextPicture();

		if (target === prev) this.prevPicture();
		if ([...dots].includes(target)) {
			currentIndex = [...dots].findIndex(elem => elem === target);
			this.changePictureWithDots(currentIndex, dots);
		}
	},

	nextPicture: function () {
		if (this.currentPictureIndex === this.picturesPath.length - 1)
			this.currentPictureIndex = 0;
		else
			this.currentPictureIndex++;

		this.setCurrentPicture(this.currentPictureIndex);
		this.changeActiveDot(this.currentPictureIndex);
	},

	prevPicture: function () {
		if (this.currentPictureIndex === 0) this.currentPictureIndex = this.picturesPath.length;
		this.currentPictureIndex--;
		this.setCurrentPicture(this.currentPictureIndex);
		this.changeActiveDot(this.currentPictureIndex);
	},

	setSwipeStart: function (event) {
		event.preventDefault();
		if (event.type === "touchstart") {
			this.swipeStart = event.touches[0].clientX;
			return false;
		}

		this.swipeStart = event.clientX;
	},

	setSwipeEnd: function (event) {
		event.preventDefault();
		if (event.type === "touchend") {
			this.swipeEnd = event.changedTouches[0].clientX;
			this.changePicture(false, true);
			return false;
		}
		this.swipeEnd = event.clientX;
		this.changePicture(false, true)
	},

	makeDots: function (activeIndex) {
		this.picturesPath.forEach((picture, index) => {
			let currentClassName = "";
			if (activeIndex === index) currentClassName = "active";
			this.dotsBlock.append(BX.create("SPAN", {
				props: {
					className: "k1-modal-dot " + currentClassName
				}
			}))
		}, this);

		this.dotsBlock.style.display = "flex";

	},

	changeActiveDot: function (currentIndex) {
		const dots = this.dotsBlock.querySelectorAll(".k1-modal-dot");
		if (dots.length < 2) return false;
		dots.forEach((dot, idx) => {
			dot.classList.remove("active");
			if (idx === currentIndex) dot.classList.add("active");
		})
	},

	changePictureWithDots: function (index) {
		this.changeActiveDot(index);
		this.setCurrentPicture(index);
	}

}